export default class CompanyIdName {
    public readonly id: number;
    public companyName: string;

    constructor(json: any) {
        this.id = json.id;
        this.companyName = json.companyName;
    }

    public toString(): string {
        return `${this.companyName}`;
    }
}
